import * as React from 'react';
import { useRecordContext } from 'react-admin';

import Chip from '@material-ui/core/Chip';

function getStatus(dataAgendamento) {
  if (!dataAgendamento) return null;

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const data = new Date(dataAgendamento);
  data.setHours(0, 0, 0, 0);

  if (data.getTime() < hoje.getTime()) return 'atrasado';
  if (data.getTime() === hoje.getTime()) return 'hoje';
  return 'futuro';
}

const StatusDataField = (props) => {
  const record = useRecordContext(props);
  const base = record && record.record ? record.record : record;
  const status = getStatus(base && base.data_agendamento);

  if (status === 'atrasado') {
    return (
      <Chip
        label="Atrasado"
        size="small"
        style={{
          backgroundColor: '#f44336',
          color: 'white',
          fontWeight: 'bold',
        }}
      />
    );
  }

  if (status === 'hoje') {
    return (
      <Chip
        label="Hoje"
        size="small"
        style={{
          backgroundColor: '#ff9800',
          color: 'white',
          fontWeight: 'bold',
        }}
      />
    );
  }

  if (status === 'futuro') {
    return (
      <Chip
        label="Em Dia"
        size="small"
        style={{
          backgroundColor: '#4caf50',
          color: 'white',
          fontWeight: 'bold',
        }}
      />
    );
  }

  return null;
};

export default StatusDataField;
